import { Loader as SemanticLoader, type LoaderProps } from "semantic-ui-react";

interface Props extends LoaderProps {}

export const AppLoader: React.FC<Props> = props => {
  return <SemanticLoader active {...props} data-testid="loader" />;
};
